import { QUICK_ADJUSTMENT_ACTIONS } from "v2/common/constants";
import { QuickAdjustmentAction } from "v3/quantConfig/types/intent.type";

export const isCaseBasedAction = (actionValue: QuickAdjustmentAction) => {
  return [
    QUICK_ADJUSTMENT_ACTIONS.CloseCase.value,
    QUICK_ADJUSTMENT_ACTIONS.OpenCase.value,
  ].includes(actionValue);
};
